import { z } from 'zod';

export const retentionRequestedSchema = z
  .object({
    reason: z.string().optional(),
  })
  .passthrough(); // допускает любые extra fields

export const retentionDoneSchema = z.object({
  total_deleted: z.number().int().nonnegative(),
  elapsed_ms: z.number().int().nonnegative(),
  by_kind: z.record(z.number().int().nonnegative()).optional(),
});
export type RetentionDonePayload = z.infer<typeof retentionDoneSchema>;
